export class ShredderOrderType {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}
